import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

import { farewellFeedResource } from './resources/farewell-feed-resource';
import { loomFeedResource } from './resources/loom-feed-resource';
import { popularFeedResource } from './resources/popular-feed-resource';
import { welcomeFeedResource } from './resources/welcome-feed-resource';

export const discoverRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'discover',
	path: '/discover',
	layout: 'home',
	resources: [loomFeedResource, popularFeedResource, welcomeFeedResource, farewellFeedResource],
});
